// garuda - Main App Component

import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {
  NavigationProvider,
  useNavigation,
  STAGES,
} from "./context/NavigationContext";

// Pages
import Home from "./pages/Home";
import Pencils from "./pages/Pencils";
import Inks from "./pages/Inks";
import Notes from "./pages/Notes";
import Activities from "./pages/Activities";
import Vault from "./pages/Vault";
import Spectacles from "./pages/Spectacles";

// Components
import Labyrinth from "./components/Labyrinth";
import Sparks from "./components/Sparks";
import TransitionOverlay from "./components/TransitionOverlay";
import TextGlitch from "./components/TextGlitch";

// Styles
import "./styles/global.css";

const AppContent = () => {
  const { currentStage, isBlackout, transitionMessage, isTransitioning } =
    useNavigation();

  // Determine which component to render based on current stage
  const renderContent = () => {
    switch (currentStage) {
      case STAGES.HOME:
        return <Home />;
      case STAGES.STAGE_1:
      case STAGES.STAGE_2A:
      case STAGES.STAGE_2B:
      case STAGES.STAGE_3A:
      case STAGES.STAGE_3B:
        return <Labyrinth />;
      case STAGES.PENCILS:
        return <Pencils />;
      case STAGES.INKS:
        return <Inks />;
      case STAGES.NOTES:
        return <Notes />;
      case STAGES.ACTIVITIES:
        return <Activities />;
      case STAGES.VAULT:
        return <Vault />;
      case STAGES.SPECTACLES:
        return <Spectacles />;
      default:
        return <Home />;
    }
  };

  return (
    <>
      {isBlackout && <div className="blackout" />}
      <TransitionOverlay
        message={transitionMessage}
        isActive={isTransitioning}
        onComplete={() => {}}
      />
      <Sparks />
      <TextGlitch />
      <div className="scanline" />
      {renderContent()}
    </>
  );
};

// Wrapper for shareable routes that includes background effects
const ShareableRoute = ({ children }) => {
  return (
    <>
      <Sparks />
      <TextGlitch />
      <div className="scanline" />
      {children}
    </>
  );
};

function App() {
  return (
    <Router>
      <NavigationProvider>
        <Routes>
          <Route path="/" element={<AppContent />} />
          <Route
            path="/inks/:slug"
            element={
              <ShareableRoute>
                <Inks />
              </ShareableRoute>
            }
          />
          <Route
            path="/notes/:topic/:slug"
            element={
              <ShareableRoute>
                <Notes />
              </ShareableRoute>
            }
          />
          <Route
            path="/vault/:category/:filename"
            element={
              <ShareableRoute>
                <Vault />
              </ShareableRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </NavigationProvider>
    </Router>
  );
}

export default App;
